import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { FormValidation, SWAL_WITH_BUTTONS } from "src/app/services/FormValidation";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";
import { UtilService } from "src/app/services/util.service";
import Swal from "sweetalert2";
import { CustomerService, TEXT_FIELDS } from "../customer-service.service";
import { ManageTemplateComponent } from "../manage-template/manage-template.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { AppSettings } from "src/app/services/AppSettings";
import { JobService } from "src/app/services/job.service";
import { PricePlanService } from "src/app/components/Price-subscritions/priceplanService";
import { NgSelectModule } from '@ng-select/ng-select';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-customer-user-details",
  standalone: true,
  imports: [CommonModule, FormsModule, ManageTemplateComponent,
NgSelectModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./customer-user-details.component.html",
  styleUrls: [
    "./customer-user-details.component.scss", '../../../../../styles/admin/style.scss',
    "../../../../../styles/admin/app.scss",
  ],
})
export class CustomerUserDetailsComponent extends FormValidation {
  columns: Array<Partial<TEXT_FIELDS>>;
  businessNetworkDetails!: any;
  userDatas = new BehaviorSubject([]);
  prevSearchAfterKey: any;
  stopScroll: boolean = false;
  payload: any = {
    limit: 10,
    searchContent: null,
    searchAfterKey: null,
    // planAccessStatus: ["ACTIVE"],
    businessId: null,
    email: null,
    groupType: 'MANAGE'
  };
  businessData: any;
  activetotalUsers: any;
  AvailableUsers: any;
  totalUsersActual: any;
  totalUsers: any;
  adminCount: any;
  url = AppSettings.photoUrl;
  constructor(
    private API: ApiService,
    private _activated_route: ActivatedRoute,
    private util: UtilService,
    private modalService: BsModalService,
    private JobServicecolor: JobService,
    private customerService :  CustomerService,
    private pricePlanService : PricePlanService 
    
  ) {
    super();

    this.columns = [
      { label: "Name", key: "fullName" },
      { label: "Email", key: "email" },
      { label: "Role", key: "role" },
    ];

    this.businessNetworkDetails = {
      networkName: "Prasnana",
      owner: "pp@gmail.com",
      members: 10,
    };

    this._activated_route.parent.data.subscribe((res) => {
      this.businessData = res.data;
    });
  }
  filterData = [
    {
      label: 'Plan Access',
      payload: 'planAccessStatus',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
        // { value: 'N/A', label: 'N/A' },
      ]
    },

  ];

  ngOnInit(): void {
    this.payload.businessId = this.businessData.id;
    this.payload.email = this.businessData.businessEmail;
    // this.payload.planAccessStatus = ["ACTIVE", "INACTIVE", "N/A"]
    this.getUsersList();



  }

  convertToTitleCase(str) {
    if (str === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION) {
      str = GigsumoConstants.MANAGER;
    }
    return str
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

   getUsersList() {
    this.util.startLoader();
    this.getCustomerUsersList(this.payload).subscribe((response) => {
      this.util.stopLoader();
      if (response.code === GigsumoConstants.SUCESSCODE) {
        const updatedUsers = response.data.customerUserAllocationList;
 
        const users = updatedUsers.map(user => ({
          ...user,
          role: this.convertToTitleCase(user.userType)
        }));
        users.forEach(x => {
          x.userType = this.convertToTitleCase(x.userType);
        })
  
        let userCountobj = response.data.customerPlanUsage.benefitsUsages?.find((item: any) => item.benefitKey === 'ACTIVE_USERS');
        const searchKey = response.data.searchAfterKey;
        this.activetotalUsers =userCountobj.utilized;
        this.AvailableUsers =userCountobj.available;
        this.totalUsersActual =userCountobj.actual;
        this.totalUsers = response.data.totalUsers;
        this.adminCount = response.data.businessAdminCount;

        if (users) {
          const current = users;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist, ...current]);
        }
        if (
          users != null && (users.length === 0 || JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))
        ) {
          this.stopScroll = true;
        }

        this.prevSearchAfterKey = searchKey;
      }


    });
  }


  // input data lables for transfer user modal;
  transferSections = [
    { key: 'JOB', label: 'Active Jobs', countKey: 'jobsCount', roleKey: 'jobs' },
    { key: 'CANDIDATE', label: 'Active Candidates', countKey: 'candidatesCount', roleKey: 'candidates' },
    { key: 'TEAM', label: 'Workspace', countKey: 'TeamsCount', roleKey: 'both' }
  ];


  onUserSelected(user: any, sectionKey: string) {
    console.log(`${sectionKey} selected user:`, user);
  } 

  selectedUsers: { [key: string]: any } = {}; // Stores selected users by JOB, CANDIDATE, TEAM
  dropdownOptions: { [key: string]: any[] } = {}; // Stores filtered user lists for each section 
  filterbyRole(userList: any[], type: string): any[] {

    console.table(`No users to filter for ${userList}`);
    // Define role mapping
    const roleMap: any = {
      jobs: ['RECRUITER', 'FREELANCE_RECRUITER', 'MANAGEMENT_TALENT_ACQUISITION', 'MANAGER'],
      candidates: ['BENCH_RECRUITER', 'FREELANCE_RECRUITER', 'MANAGEMENT_TALENT_ACQUISITION', 'MANAGER'],
    };
    
    // Combine job and candidate roles without duplicates
    roleMap.both = [...new Set([...roleMap.jobs, ...roleMap.candidates])];
    
    if (!userList || userList.length === 0) {
      console.log(`No users to filter for ${type}`);
      return [];
    }
    
    // Filter users based on their userType matching the roles in roleMap[type]
    const filteredUsers = userList.filter(item => {
      // Get the userType, ensure it's a string and uppercase for comparison
      const userType = (item.userType || '').toString().toUpperCase();
      return roleMap[type]?.includes(userType);
    });
    
    console.log(`Filtered ${filteredUsers.length} users for ${type} from ${userList.length} total users`);
    return filteredUsers;
  }
 // Final fixed buildTransferPayload method based on the actual API response structure
buildTransferPayload(): any {
  console.log("Building transfer payload with data:", this.responseTransfreUser);
  
  // Create an array to hold our transfers
  const transfers = []; 
  // Handle JOB transfer - using candidateActiveDetails array
  if (this.responseTransfreUser?.jobsCount > 0 && this.selectedUsers['JOB']) {
    // console.log("CANDIDATE transfer selected:", this.selectedUsers['JOB']);
    const targetUserId = typeof this.selectedUsers['JOB'] === 'object'
      ? this.selectedUsers['JOB']
      : this.selectedUsers['JOB'];
      
    // Extract just the job IDs from jobsActiveDetails
    const jobIds = this.responseTransfreUser.jobsDetails?.map(job => job.jobId || job.jobReferenceId) || [];
    
    transfers.push({
      benefitKey: "JOB",
      targetUserId: targetUserId || "",
      jobs: jobIds
    });
  }
  
  // Handle CANDIDATE transfer - using candidateActiveDetails array
  if (this.responseTransfreUser?.candidatesCount > 0 && this.selectedUsers['CANDIDATE']) {
    // console.log("CANDIDATE transfer selected:", this.selectedUsers['CANDIDATE']);
    const targetUserId = typeof this.selectedUsers['CANDIDATE'] === 'object'
      ? this.selectedUsers['CANDIDATE']
      : this.selectedUsers['CANDIDATE'];
      
    // Extract just the candidate IDs from candidateActiveDetails
    const candidateIds = this.responseTransfreUser.candidateDetails?.map(candidate => 
      candidate.candidateId || candidate.candidateReferenceId) || [];
    
    transfers.push({
      benefitKey: "CANDIDATE",
      targetUserId: targetUserId || "",
      candidates: candidateIds
    });
  }
  
  // Handle TEAM transfer - using teamActiveDetails array
  if (this.responseTransfreUser?.TeamsCount > 0 && this.selectedUsers['TEAM']) {
    const targetUserId = typeof this.selectedUsers['TEAM'] === 'object'
      ? this.selectedUsers['TEAM']
      : this.selectedUsers['TEAM'];
      
    // Extract just the team IDs from teamActiveDetails
    const teamIds = this.responseTransfreUser.teamDetails?.map(team => team.teamId) || [];
    
    transfers.push({
      benefitKey: "TEAM",
      targetUserId: targetUserId || "",
      teams: teamIds
    });
  }
  
  // Construct the final payload in the exact format required
  const payload = {
    organisationId: this.businessData.organisationId || "",
    sourceUserId: this.turnoffuseIdforTransfer,
    transfers: transfers
  };
  
  console.log("Final payload:", payload);
  return payload;
}


   // Method to actually send the transfer request with corrected error handling



  transferClicked = false;
 transferUserData() {
  this.transferClicked = true;
  const availableSlots = this.transferSections.filter(item => this.responseTransfreUser?.[item.countKey] > 0)
  const hasMissingUser = availableSlots.some(section => !this.selectedUsers[section.key]);

  if (hasMissingUser) {
    console.log('had missing user : ',hasMissingUser);    
    return;
  }


  const payload = this.buildTransferPayload();
  
  // Don't proceed if there are no transfers
  if (payload.transfers.length === 0) {
    console.log("No transfers selected");
    // Using SweetAlert instead of util.showErrorMessage
    Swal.fire({
      icon: "error",
      title: "No Selection",
      text: "Please select at least one user to transfer data to",
      confirmButtonText: "OK"
    });
    return;
  }
  
  console.log("Sending transfer request with payload:", payload);
  
  this.util.startLoader();
  this.API.create("business/userEntityTransfer", payload).subscribe(response => {
    this.util.stopLoader();
    this.transferClicked = false;

     if (response.code === GigsumoConstants.SUCESSCODE) {
      this.modalRef.hide();
      this.selectedUser = "";
      Swal.fire({
        icon: "success",
        title: "Transfer Complete",
        text: "User data transferred successfully",
        showConfirmButton: false,
        timer: 2000,
      });
      // Refresh the user list and count data after successful transfer
      setTimeout(() => {
        this.payload.searchAfterKey = null;
        this.prevSearchAfterKey = null;
        this.stopScroll = false;
        this.userDatas.next([]);
        this.getUsersList();
      }, 1000);
    } else {
      // Using SweetAlert for error message instead of util.showErrorMessage
      Swal.fire({
        icon: "error",
        title: "Transfer Failed",
        text: response.message || "Failed to transfer user data",
        confirmButtonText: "OK"
      });
    }
  }, error => {
    this.util.stopLoader();
    // Using SweetAlert for error message instead of util.showErrorMessage
    Swal.fire({
      icon: "error",
      title: "Transfer Failed",
      text: "Failed to transfer user data",
      confirmButtonText: "OK"
    });
  });
}
 
 
  selectedUser: any = null; 
  modalRef: any;
  closeModal() {
    this.modalRef.hide();
    this.selectedUser = "";
    this.UpdateuserToggle();
    this.transferClicked = false;
  }

  // Update the user status if i cancel the transfer user modal;
  UpdateuserToggle() {
    const updatedUsers = this.userDatas.getValue().map((user: any) => {
      if (user.userId === this.turnoffuseIdforTransfer) {
        return { ...user, planAccessStatus: "ACTIVE", enabled: true };
      }
      return user;
    });
    this.userDatas.next(updatedUsers);
  }

  openModel(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });
  }

 

  selectUser(item: any) {
    console.log(item)

  }


  // User Letter Update profile
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }



  getCustomerUsersList(payload: Object): Observable<any> {
    return this.API.create(
      "subscription/findEmployeeBenefitsAllocation",
      payload
    );
  }



  // selected user for transfer user modal;
  selectedJobUser: any = null;
  selectedCandidateUser: any = null;
  selectedTeamUser: any = null;

  dropdowns = [
    { key: 'jobs', label: 'Total Jobs', countKey: 'jobsCount', model: 'selectedJobUser' },
    { key: 'candidates', label: 'Total Candidates', countKey: 'candidatesCount', model: 'selectedCandidateUser' },
    { key: 'both', label: 'Workspace', countKey: 'TeamsCount', model: 'selectedTeamUser' },
  ];

 




  updateBusinessNetwork(event) { }



  // API call for fetch Job Candidate Team Details and count's to display in the transfer user model;
  responseTransfreUser: any = {
    jobsCount: Number,
    candidatesCount: Number,
    TeamsCount: Number,
    jobs: [],
    candidates: [],
    teams: []
  };

  APIforFetchJobCandidateTeamDetails() {
    let payload = { "userId": this.turnoffuseIdforTransfer };
    this.API.create("user/fetchJobCandidateTeamDetails", payload).subscribe((response) => {
      if (response.code === GigsumoConstants.SUCESSCODE) {
        console.log("Job/Candidate API Response:", response.data);
        this.responseTransfreUser = response.data; 
        if(!this.NoDatafroTransfer()){
          this.modalRef = this.modalService.show(this.turnoffUserTemplate, {
            animated: true,
            backdrop: "static",
          });
          this.isModalOpen = true;
        }else{
          // if there is no data in the transfer user modal not showing and direlctly calling the API for transfer user;
          let payload :any={};
           payload.sourceUserId = this.turnoffuseIdforTransfer;
           payload.organisationId = this.businessData.organisationId;
           this.API.create("business/userEntityTransfer", payload).subscribe(response => {
             if (response.code === GigsumoConstants.SUCESSCODE) {
              Swal.fire({
                icon: "success",
                title: "Plan Access Stopped Successfully",
                showConfirmButton: false,
                timer: 2000,
              });
              // Refresh the user list and count data after successful deactivation
              setTimeout(() => {
                this.payload.searchAfterKey = null;
                this.prevSearchAfterKey = null;
                this.stopScroll = false;
                this.userDatas.next([]);
                this.getUsersList();
              }, 1000);
             }  
          })

        }

      
        
        // Call userListAPI here to ensure we have the user list before filtering
        this.userListAPI();
      }
    });
  }

  // If all data are zero then show no data in transfer user modal;
  NoDatafroTransfer(): boolean {
    if (!this.responseTransfreUser) return true;
    return (
      this.responseTransfreUser.jobsCount === 0 &&
      this.responseTransfreUser.candidatesCount === 0 &&
      this.responseTransfreUser.TeamsCount === 0
    );
  }




  // this for transfer user data load 1000 recored at a time and we have one more api for user api but that one for listing user and this one for dropdown user;
  userloadforFilterPayload: any = {
    "limit": 1000,
    "page": 0,
    "searchAfterKey": null, 
    "groupType": "LISTING",
    "businessId": "",
    "email": localStorage.getItem('userName')
  }
  userList: any = [];
  userListAPI() {
    this.userloadforFilterPayload.businessId = this.businessData.id;
    this.util.startLoader();
    
    this.API.create('subscription/findEmployeeBenefitsAllocation', this.userloadforFilterPayload).subscribe(response => {
      this.util.stopLoader();
      
      if (response.code === GigsumoConstants.SUCESSCODE) {
        // FIX: Get the actual user list array from the correct path in the response
        const userList = response.data.customerUserAllocationList || [];
        console.log("User List received:", userList);
        
        if (userList && userList.length > 0) { 
          this.userList = userList;

          // Selected user no need assing to him so i removed here
          if (this.turnoffuseIdforTransfer) {
            const index = userList.findIndex(user => user.userId === this.turnoffuseIdforTransfer);
            if (index !== -1) {
              this.userList.splice(index, 1);  
            }
          }
   
          
          // Populate dropdown options for each section
          this.transferSections.forEach(section => {
            // Filter the user list by role type for each section
            this.dropdownOptions[section.key] = this.filterbyRole(userList, section.roleKey);
            console.log(`Filtered options for ${section.key}:`, this.dropdownOptions[section.key]);
          });
        } else {
          console.error("No users found in the response or empty user list");
          // Initialize empty arrays for each dropdown
          this.transferSections.forEach(section => {
            this.dropdownOptions[section.key] = [];
          });
        }
      } else {
        console.error("API Error:", response);
      }
    });
  }

  // get data from manage temaplate component for transfer user modal;

  turnoffuseIdforTransfer: any = null;
  @ViewChild('turnoffUser') turnoffUserTemplate!: TemplateRef<any>;
  async updateBusinessNetworkMembers(members: any) {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to change the plan access status?',
    icon: 'warning',
    showCancelButton: true,
    allowEscapeKey: false,
    allowOutsideClick: false,
    cancelButtonText: 'No',
     confirmButtonText: 'Yes',
  }).then(result => result.isConfirmed);

  if (!confirmed) {
    // Revert toggle if cancelled
    const userId = members.value.userId;
    const updatedUsers = this.userDatas.getValue().map((user: any) => {
      if (user.userId === userId) {
        return { ...user, enabled: !members.checked }; // revert the toggle to old status 
      }
      return user;
    });
    this.userDatas.next(updatedUsers);
    return;  
  }


  const userData = members.value;
  this.turnoffuseIdforTransfer = userData.userId;
  userData.planAccessStatus = members.checked ? 'ACTIVE' : 'INACTIVE';

  if (userData.userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION) {
    userData.userType = GigsumoConstants.MANAGER;
  }

  userData.userType = userData.userType.replaceAll("_", " ");

  if (members.checked) {
    const plan = await this.customerService.getBusinessPLanBenefits(this.businessData.id, 'ACTIVE_USERS');
    if (plan.available > 0) {
      this.updateMembersBulk(userData);
    } else {
      const updatedUsers = this.userDatas.getValue().map((user: any) => {
        if (user.userId === this.turnoffuseIdforTransfer) {
          return { ...user, planAccessStatus: "INACTIVE", enabled: false };
        }
        return user;
      });
      this.userDatas.next(updatedUsers);

      this.pricePlanService.expiredPopup(
        "ACTIVE_USERS",
        "LIMIT",
        null,
        null,
        null,
        null,
        plan.available,
        plan.actual,
        plan.utilized,
        plan.promotional
      );
    }
  } else {
    this.selectedUsers = {};
    this.dropdownOptions = {};
    this.APIforFetchJobCandidateTeamDetails();
  }
}

 
  

 // API call to get the business plan benefits for the App access togggle; ;
  async getBusinessPLanBenefits() {
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.businessData.id);
    const plan = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    if (plan) {
      return plan.find(x => x.benefitKey === "ACTIVE_USERS");
    }
  }


  updateMembersBulk(data) {
    if (data.userType === GigsumoConstants.MANAGER) {
      data.userType = GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION;
    }
    data.userType = data.userType.replaceAll(' ', "_").toUpperCase(); 
    this.util.startLoader(); 

    // New API call for activating plan access for user changed by thiru
    // this.API.create('user/manageUsers', [data]).subscribe(response => { 

      let payload:any={}
      payload.userId = this.turnoffuseIdforTransfer; 
      this.API.create('business/activatePlanAccess', payload).subscribe(response => {
      if (response.code === GigsumoConstants.SUCESSCODE) {
        this.util.stopLoader();
        Swal.fire({
          icon: "success",
          title: "User Updated",
          text: "User updated successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.userDatas.next([]);
          this.getUsersList();
        }, 1000);
      }
    });
  }

  onSearch(value, obj: CustomerUserDetailsComponent) {
    obj.payload = {
      ...obj.payload,
      searchContent: value,
      searchAfterKey: null,
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getUsersList();
  }

  onFilter(data, obj: CustomerUserDetailsComponent) {
    console.log("FILTERED DATA", data);

    obj.payload = {
      ...obj.payload,
      // planAccessStatus: data.planAccessStatus ? [data.planAccessStatus] : ["ACTIVE", "INACTIVE", "N/A"],
      planAccessStatus: data.planAccessStatus ? [data.planAccessStatus] : null,
      searchAfterKey: null,
    };

    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);

    obj.getUsersList();
  }

  onScroll(obj: CustomerUserDetailsComponent) {
    console.log("Stop SCrolled ", this.stopScroll, obj);

    if (!obj.stopScroll) {
      obj.payload = {
        ...obj.payload,
        searchAfterKey: obj.prevSearchAfterKey,
      };
      obj.getUsersList();
    }
  }
}
